const selectHaPedidoEmAndamento = (state): boolean => {
  const { idPedidoAndamento } = state.recebaAntes
  return !!idPedidoAndamento
}

export { selectHaPedidoEmAndamento }
